// import React from 'react';
// import styled from 'styled-components';

// // --- Styled Components ---

// const PricingContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding: 3rem 0.5rem;
//   background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
//   min-height: 100vh;
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
// `;

// const PricingWrapper = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 320px));
//   gap: 2rem;
//   width: 100%;
//   max-width: 700px;
//   justify-content: center;
//   align-items: stretch;
// `;

// const PriceCard = styled.div`
//   background: ${(props) => (props.$highlighted ? 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)' : '#ffffff')};
//   color: ${(props) => (props.$highlighted ? '#ffffff' : '#1e293b')};
//   border-radius: 20px;
//   padding: 2.5rem 2rem;
//   box-shadow: ${(props) =>
//     props.$highlighted ? '0 20px 35px rgba(59, 130, 246, 0.3)' : '0 10px 25px rgba(0, 0, 0, 0.05)'};
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   position: relative;
//   border: ${(props) => (props.$highlighted ? 'none' : '1px solid #e2e8f0')};
//   transform: ${(props) => (props.$highlighted ? 'scale(1.03)' : 'none')};
//   transition: transform 0.3s ease;

//   &:hover {
//     transform: ${(props) => (props.$highlighted ? 'scale(1.05)' : 'translateY(-5px)')};
//   }
// `;

// const Badge = styled.span`
//   position: absolute;
//   top: -12px;
//   right: 20px;
//   background: #f59e0b;
//   color: #ffffff;
//   font-size: 0.75rem;
//   font-weight: 700;
//   text-transform: uppercase;
//   padding: 0.35rem 0.85rem;
//   border-radius: 50px;
//   letter-spacing: 0.5px;
//   box-shadow: 0 4px 10px rgba(245, 158, 11, 0.3);
// `;

// const PlanHeader = styled.div`
//   text-align: center;
//   margin-bottom: 1.5rem;

//   h3 {
//     font-size: 1.25rem;
//     font-weight: 700;
//     margin: 0 0 0.5rem 0;
//     color: ${(props) => (props.$highlighted ? '#ffffff' : '#0f172a')};
//     word-break: break-word;
//   }

//   p {
//     font-size: 0.9rem;
//     opacity: ${(props) => (props.$highlighted ? '0.9' : '0.6')};
//     margin: 0;
//     word-break: break-word;
//   }
// `;

// const PriceDisplay = styled.div`
//   text-align: center;
//   margin-bottom: 2rem;
//   padding: 1.5rem 0;
//   border-top: 1px solid ${(props) => (props.$highlighted ? 'rgba(255, 255, 255, 0.15)' : '#f1f5f9')};
//   border-bottom: 1px solid ${(props) => (props.$highlighted ? 'rgba(255, 255, 255, 0.15)' : '#f1f5f9')};

//   .currency {
//     font-size: 1.25rem;
//     font-weight: 600;
//     vertical-align: super;
//   }

//   .amount {
//     font-size: 2.5rem;
//     font-weight: 800;
//     letter-spacing: -1px;
//     word-break: break-all;
//   }

//   .period {
//     display: block;
//     font-size: 0.85rem;
//     margin-top: 0.25rem;
//     opacity: ${(props) => (props.$highlighted ? '0.8' : '0.5')};
//     word-break: break-word;
//   }
// `;

// const FeatureList = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 0 0 2rem 0;
//   flex-grow: 1;

//   li {
//     display: flex;
//     align-items: flex-start;
//     gap: 0.75rem;
//     font-size: 0.9rem;
//     margin-bottom: 0.85rem;
//     color: ${(props) => (props.$highlighted ? '#f8fafc' : '#475569')};
//     word-break: break-word;

//     svg {
//       color: ${(props) => (props.$highlighted ? '#60a5fa' : '#10b981')};
//       flex-shrink: 0;
//       margin-top: 2px;
//     }
//   }
// `;

// const ApplyButton = styled.a`
//   display: block;
//   width: 100%;
//   padding: 0.85rem 1rem;
//   background: ${(props) => (props.$highlighted ? '#ffffff' : '#2563eb')};
//   color: ${(props) => (props.$highlighted ? '#1e3a8a' : '#ffffff')};
//   text-align: center;
//   border-radius: 12px;
//   font-weight: 700;
//   font-size: 0.95rem;
//   text-decoration: none;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//   transition: all 0.2s ease;
//   word-break: break-word;

//   &:hover {
//     background: ${(props) => (props.$highlighted ? '#f1f5f9' : '#1d4ed8')};
//     transform: translateY(-2px);
//     box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
//   }
// `;

// // --- Component ---

// export default function ProgramPricing() {
//   return (
//     <PricingContainer>
//       <PricingWrapper>
//         {/* Standard Child Plan */}
//         <PriceCard>
//           <PlanHeader>
//             <h3>Standard Batch</h3>
//             <p>For single-child enrollment</p>
//           </PlanHeader>
//           <PriceDisplay>
//             <span className="currency">N</span>
//             <span className="amount">50,000</span>
//             <span className="period">per child / batch</span>
//           </PriceDisplay>
//           <FeatureList>
//             <li>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
//               Full online class access
//             </li>
//             <li>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
//               Interactive Google Meet sessions
//             </li>
//             <li>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
//               Dedicated learning materials
//             </li>
//           </FeatureList>
//           <ApplyButton href="/codingapplicationfaq" $highlighted={false}>
//             Proceed to Application
//           </ApplyButton>
//         </PriceCard>

//         {/* Sibling Discount Plan */}
//         <PriceCard $highlighted={true}>
//           <Badge>Best Value</Badge>
//           <PlanHeader $highlighted={true}>
//             <h3>Sibling Discount</h3>
//             <p>For families with more than one child</p>
//           </PlanHeader>
//           <PriceDisplay $highlighted={true}>
//             <span className="currency">N</span>
//             <span className="amount">45,000</span>
//             <span className="period">per child / batch</span>
//           </PriceDisplay>
//           <FeatureList $highlighted={true}>
//             <li>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
//               All standard batch benefits included
//             </li>
//             <li>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
//               Discounted rate applied per child
//             </li>
//             <li>
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
//               Multi-child learning support
//             </li>
//           </FeatureList>
//           <ApplyButton href="/codingapplicationfaq" $highlighted={true}>
//             Proceed to Application
//           </ApplyButton>
//         </PriceCard>
//       </PricingWrapper>
//     </PricingContainer>
//   );
// }





import React from 'react';
import styled from 'styled-components';

// --- Styled Components ---

const PricingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const PricingWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 320px));
  gap: 10px;
  width: 100%;
  max-width: 700px;
  justify-content: center;
  align-items: stretch;
`;

const PriceCard = styled.div`
  background: ${(props) => (props.$highlighted ? 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)' : '#ffffff')};
  color: ${(props) => (props.$highlighted ? '#ffffff' : '#1e293b')};
  border-radius: 10px;
  padding: 10px;
  box-shadow: ${(props) =>
    props.$highlighted ? '0 10px 20px rgba(59, 130, 246, 0.3)' : '0 4px 10px rgba(0, 0, 0, 0.05)'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  border: ${(props) => (props.$highlighted ? 'none' : '1px solid #e2e8f0')};
  transform: ${(props) => (props.$highlighted ? 'scale(1.02)' : 'none')};
  transition: transform 0.3s ease;

  &:hover {
    transform: ${(props) => (props.$highlighted ? 'scale(1.03)' : 'translateY(-2px)')};
  }
`;

const Badge = styled.span`
  position: absolute;
  top: -8px;
  right: 10px;
  background: #f59e0b;
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 50px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.3);
`;

const PlanHeader = styled.div`
  text-align: center;
  margin-bottom: 10px;

  h3 {
    font-size: 1.15rem;
    font-weight: 700;
    margin: 0 0 4px 0;
    color: ${(props) => (props.$highlighted ? '#ffffff' : '#0f172a')};
    word-break: break-word;
  }

  p {
    font-size: 0.85rem;
    opacity: ${(props) => (props.$highlighted ? '0.9' : '0.6')};
    margin: 0;
    word-break: break-word;
  }
`;

const PriceDisplay = styled.div`
  text-align: center;
  margin-bottom: 10px;
  padding: 8px 0;
  border-top: 1px solid ${(props) => (props.$highlighted ? 'rgba(255, 255, 255, 0.15)' : '#f1f5f9')};
  border-bottom: 1px solid ${(props) => (props.$highlighted ? 'rgba(255, 255, 255, 0.15)' : '#f1f5f9')};

  .currency {
    font-size: 1.1rem;
    font-weight: 600;
    vertical-align: super;
  }

  .amount {
    font-size: 2.1rem;
    font-weight: 800;
    letter-spacing: -1px;
    word-break: break-all;
  }

  .period {
    display: block;
    font-size: 0.8rem;
    margin-top: 2px;
    opacity: ${(props) => (props.$highlighted ? '0.8' : '0.5')};
    word-break: break-word;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 10px 0;
  flex-grow: 1;

  li {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 0.85rem;
    margin-bottom: 6px;
    color: ${(props) => (props.$highlighted ? '#f8fafc' : '#475569')};
    word-break: break-word;

    svg {
      color: ${(props) => (props.$highlighted ? '#60a5fa' : '#10b981')};
      flex-shrink: 0;
      margin-top: 2px;
    }
  }
`;

const SessionContainer = styled.div`
  background: ${(props) => (props.$highlighted ? 'rgba(255, 255, 255, 0.1)' : '#f8fafc')};
  border: 1px solid ${(props) => (props.$highlighted ? 'rgba(255, 255, 255, 0.2)' : '#e2e8f0')};
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 10px;

  h4 {
    font-size: 0.85rem;
    margin: 0 0 6px 0;
    font-weight: 700;
    color: ${(props) => (props.$highlighted ? '#ffffff' : '#1e293b')};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

const SessionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SessionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: ${(props) => (props.$highlighted ? '#f1f5f9' : '#334155')};
  word-break: break-word;

  span:first-child {
    font-weight: 600;
  }

  span:last-child {
    opacity: 0.9;
    font-size: 0.75rem;
  }
`;

const ApplyButton = styled.a`
  display: block;
  width: 100%;
  padding: 8px 10px;
  background: ${(props) => (props.$highlighted ? '#ffffff' : '#2563eb')};
  color: ${(props) => (props.$highlighted ? '#1e3a8a' : '#ffffff')};
  text-align: center;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.9rem;
  text-decoration: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  word-break: break-word;

  &:hover {
    background: ${(props) => (props.$highlighted ? '#f1f5f9' : '#1d4ed8')};
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }
`;

// --- Component ---

export default function ProgramPricing() {
  return (
    <PricingContainer>
      <PricingWrapper>
        {/* Standard Child Plan */}
        <PriceCard>
          <PlanHeader>
            <h3>Standard Batch</h3>
            <p>For single-child enrollment</p>
          </PlanHeader>
          <PriceDisplay>
            <span className="currency">N</span>
            <span className="amount">50,000</span>
            <span className="period">per child / batch</span>
          </PriceDisplay>
          <FeatureList>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              Full online class access
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              Interactive Google Meet
            </li>
          </FeatureList>

          <SessionContainer>
            <h4>Available Sessions</h4>
            <SessionList>
              <SessionItem>
                <span>Morning</span>
                <span>9:30 AM - 12:00 PM</span>
              </SessionItem>
              <SessionItem>
                <span>Afternoon</span>
                <span>12:30 PM - 3:00 PM</span>
              </SessionItem>
              <SessionItem>
                <span>Evening</span>
                <span>3:30 PM - 5:30 PM</span>
              </SessionItem>
            </SessionList>
          </SessionContainer>

          <ApplyButton href="/codingapplicationfaq" $highlighted={false}>
            Proceed to Application
          </ApplyButton>
        </PriceCard>

        {/* Sibling Discount Plan */}
        <PriceCard $highlighted={true}>
          <Badge>Best Value</Badge>
          <PlanHeader $highlighted={true}>
            <h3>Sibling Discount</h3>
            <p>For families with more than one child</p>
          </PlanHeader>
          <PriceDisplay $highlighted={true}>
            <span className="currency">N</span>
            <span className="amount">45,000</span>
            <span className="period">per child / batch</span>
          </PriceDisplay>
          <FeatureList $highlighted={true}>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              All standard benefits included
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              Discounted rate per child
            </li>
          </FeatureList>

          <SessionContainer $highlighted={true}>
            <h4>Available Sessions</h4>
            <SessionList>
              <SessionItem $highlighted={true}>
                <span>Morning</span>
                <span>9:30 AM - 12:00 PM</span>
              </SessionItem>
              <SessionItem $highlighted={true}>
                <span>Afternoon</span>
                <span>12:30 PM - 3:00 PM</span>
              </SessionItem>
              <SessionItem $highlighted={true}>
                <span>Evening</span>
                <span>3:30 PM - 5:30 PM</span>
              </SessionItem>
            </SessionList>
          </SessionContainer>

          <ApplyButton href="/codingapplicationfaq" $highlighted={true}>
            Proceed to Application
          </ApplyButton>
        </PriceCard>
      </PricingWrapper>
    </PricingContainer>
  );
}